// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1vC3b","header":"ReportDetails_header__3DX1t","title":"ReportDetails_title__y-3QA","left":"ReportDetails_left__HPZpS"};